
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  acl: [],
};

const aclSlice = createSlice({
  name: "acl",
  initialState,
  reducers: {
    setAcl: (state, action) => {
      state.acl = action.payload;
    },
    clearAcl: (state) => {
      state.user = null;
    },
  },
});

export const { setAcl,clearAcl} = aclSlice.actions;
export default aclSlice.reducer;
